
import { Component, Vue } from 'vue-property-decorator';
import { supportedLanguages } from '@/util/i18n';

@Component
export default class Parts extends Vue {
  private get selectedLocale(): string {
    return this.$store.getters['i18n/locale'];
  }

  private set selectedLocale(value: string) {
    this.$store.dispatch('i18n/setLocaleWithi18n', { locale: value });
  }

  private language(locale: string): string {
    return supportedLanguages[locale as keyof typeof supportedLanguages];
  }
}
